import { formatCurrency } from "@src/utilities/format-numbers"

export interface CheckoutLineItemProps {
  cartPrice: number
  description?: string | null
  frequencyInWeeks?: number
  name: string
  retailPrice: number
  quantity: number
  thumbnailUrl?: string | null
}
export default function CheckoutLineItem({
  cartPrice,
  description,
  frequencyInWeeks,
  name,
  retailPrice,
  quantity,
  thumbnailUrl,
}: CheckoutLineItemProps) {
  return (
    <div className="mb-4" data-component="checkout-line-item">
      <div className="flex items-start">
        <div
          className="block bg-center bg-cover w-20 border border-gray-300 rounded-sm before:content-[''] before:block before:pt-[100%] mr-3"
          style={{
            backgroundImage: `url(${
              thumbnailUrl ?? "/images/placeholder.jpeg"
            })`,
          }}
        />
        <div className="grow">
          <h5
            className="font-browser font-bold text-base"
            dangerouslySetInnerHTML={{ __html: name }}
          />
          <h6
            className="font-browser text-gray-600 text-xs"
            dangerouslySetInnerHTML={{
              __html: description ?? "",
            }}
          />
          {frequencyInWeeks && (
            <p className="font-browser text-gray-600 text-xs">
              Delivered every {frequencyInWeeks} weeks
            </p>
          )}
          <p className="font-browser mt-2 text-gray-600 text-xs">
            Quantity x {quantity}
          </p>
          <div className="font-browser font-medium mb-2 md:hidden">
            <div>
              {formatCurrency(cartPrice)}
              {cartPrice < retailPrice && (
                <span className="ml-1 font-normal text-xs text-orange line-through">
                  ({formatCurrency(retailPrice)})
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="ml-4 md:text-right">
          <div className="hidden md:block">
            <div className="font-medium">{formatCurrency(cartPrice)}</div>
            {cartPrice < retailPrice && (
              <div className="font-normal text-xs text-orange line-through">
                {formatCurrency(retailPrice)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
